import {
    GetOrganizationsSortOptionType,
    OrganizationSortDirection,
    type GetOrganizationsQuery,
    type OrganizationListItem,
} from "@models/organization";

// #333 (Rulings 2026-11-02): the Clients columns that sort. Each column's id
// (its accessorKey) and the GET /organizations sortBy it asks for.
export const CLIENT_SORT_BY = {
    pendingLocationsCount: GetOrganizationsSortOptionType.PendingLocationsCount,
} satisfies Partial<
    Record<keyof OrganizationListItem, GetOrganizationsSortOptionType>
>;

export type ClientSortColumn = keyof typeof CLIENT_SORT_BY;

export interface ClientSort {
    columnId: ClientSortColumn;
    desc: boolean;
}

const isClientSortColumn = (value: string): value is ClientSortColumn =>
    Object.keys(CLIENT_SORT_BY).includes(value);

/**
 * The sort `?sortBy=<column id>&sortDirection=asc|desc` names, or null for
 * none (no sort, an unknown column or direction): the list's own order.
 */
export const parseClientSort = (
    sortBy: string | null,
    sortDirection: string | null,
): ClientSort | null =>
    sortBy !== null &&
    isClientSortColumn(sortBy) &&
    (sortDirection === "asc" || sortDirection === "desc")
        ? { columnId: sortBy, desc: sortDirection === "desc" }
        : null;

/**
 * GET /organizations' sortBy and sortDirection for a sort. None for no sort,
 * so DEFAULT_ORGANIZATIONS_QUERY's order (Submitted, newest first) stands.
 */
export const toOrganizationsQuerySort = (
    sort: ClientSort | null,
): Pick<GetOrganizationsQuery, "sortBy" | "sortDirection"> =>
    sort
        ? {
            sortBy: [CLIENT_SORT_BY[sort.columnId]],
            sortDirection: sort.desc
                ? OrganizationSortDirection.Desc
                : OrganizationSortDirection.Asc,
        }
        : {};
